<template>
  <v-container>
    <div><b> Event</b></div>
    <br />
    <v-card>
      <v-row class="mx-3 pt-2">
        <v-col cols="12" sm="6" class="d-flex align-center">
          <v-text-field
            :label="'Cari berdasarkan ' + berdasarkan"
            outlined
            dense
            v-if="berdasarkan == 'id'"
            v-model="search"
            :suffix="'| Berdasarkan ' + berdasarkan"
            @keyup.enter="tabIklan('cariId')"
          >
            <template v-slot:append>
              <v-menu down offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    <v-icon>
                      mdi-chevron-down
                    </v-icon>
                  </div>
                </template>
                <v-list class="px-4">
                  <v-list-item @click="berdasarkan = 'id'"
                    >Berdasarkan Id</v-list-item
                  >
                </v-list>
                <v-list class="px-4">
                  <v-list-item @click="(berdasarkan = 'pengguna'), getUser()"
                    >Berdasarkan Pengguna</v-list-item
                  >
                </v-list>
              </v-menu>
            </template>
          </v-text-field>
          <v-text-field
            :label="'Cari berdasarkan ' + berdasarkan"
            outlined
            dense
            @click="daftarUser = true"
            @keyup="getUser()"
            @keyup.enter="tabIklan('searchPengguna')"
            v-if="berdasarkan == 'pengguna'"
            v-model="search"
            :suffix="'| Berdasarkan ' + berdasarkan"
          >
            <template v-slot:append>
              <v-menu down offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    <v-icon>
                      mdi-chevron-down
                    </v-icon>
                  </div>
                </template>
                <v-list class="px-4">
                  <v-list-item @click="berdasarkan = 'id'"
                    >Berdasarkan Id</v-list-item
                  >
                </v-list>
                <v-list class="px-4">
                  <v-list-item @click="berdasarkan = 'pengguna'"
                    >Berdasarkan Pengguna</v-list-item
                  >
                </v-list>
              </v-menu>
            </template>
          </v-text-field>
        </v-col>
        <v-col cols="12" sm="3" class="d-flex align-center">
          <v-select
            outlined
            :items="inijenisIklan"
            dense
            v-model="jenis"
            single-line
            @change="tabIklan('filterJenis')"
          ></v-select>
        </v-col>
        <v-col cols="12" sm="3" class="d-flex align-center">
          <v-btn
            :style="{
              background: 'linear-gradient(to right, #c90000, #f9c72a)',
              color: 'white'
            }"
            to="/add-event"
            class="white--text"
            style="margin-top:-25px"
          >
            Tambah Iklan
          </v-btn>
        </v-col>
        <v-col
          v-if="berdasarkan == 'pengguna' && daftarUser == true"
          cols="12"
          sm="6"
          style="position:absolute;z-index:10"
          class="mt-11"
        >
          <v-list elevation="1" style="width:97%">
            <v-list-item class="mb-4">
              <table style="width:100%">
                <tr
                  v-for="(item, i) in iniListUser"
                  :key="i"
                  @click="memilihUser(item)"
                  style="cursor:pointer"
                >
                  <td style="width:70px">
                    <v-avatar>
                      <v-img src="img/beat.png"></v-img>
                    </v-avatar>
                  </td>
                  <td>{{ item.nama }}</td>
                  <td class="text-right">
                    <v-icon>
                      mdi-chevron-right
                    </v-icon>
                  </td>
                </tr>
              </table>
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>

      <div class="d-flex ml-6">
        <div
          :style="
            semua == 'Berlangsung'
              ? 'background: #ffeeee;border: 2px solid #c90000;border-radius: 10px;cursor:pointer'
              : 'border: 2px solid #e5e5e5; border-radius: 10px;cursor:pointer'
          "
          class="px-4 py-2"
          @click="tabIklan('Berlangsung')"
        >
          Berlangsung(12483)
        </div>
        <div
          :style="
            semua == 'Tayang'
              ? 'background: #ffeeee;border: 2px solid #c90000;border-radius: 10px;cursor:pointer'
              : 'border: 2px solid #e5e5e5; border-radius: 10px;cursor:pointer'
          "
          class="px-4 py-2 ml-2"
          @click="tabIklan('Tayang')"
        >
          Tayang(12483)
        </div>
        <div
          :style="
            semua == 'Selesai'
              ? 'background: #ffeeee;border: 2px solid #c90000;border-radius: 10px;cursor:pointer'
              : 'border: 2px solid #e5e5e5; border-radius: 10px;cursor:pointer'
          "
          class="px-4 py-2 ml-2"
          @click="tabIklan('Selesai')"
        >
          Selesai(12483)
        </div>
      </div>
      <br />
      <br />
      <v-row class="mx-1">
        <v-col
          cols="12"
          sm="3"
          v-for="item in dataIklan"
          :key="item._source.id"
        >
          <ListIklans :item="item" :event="'event'" />
        </v-col>
      </v-row>
      <br />
      <div align="center">
        <v-btn
          color="#c90000"
          dark
          outlined
          @click="getDataIklan"
          v-if="dataIklan.length < 1000 && dataIklan.length < total"
        >
          Muat Lebih Banyak
        </v-btn>
      </div>
      <br />
    </v-card>

    <br />
    <br />
  </v-container>
</template>

<script>
import 'firebase/firestore';
import moment from 'moment-timezone';
import ListIklans from '@/components/ListIklans.vue';

export default {
  components: {
    ListIklans
  },
  name: 'ListIklan',
  data: () => ({
    selected: [2],

    LogTransaksi: null,
    itemsPerPage: 999,
    DetailIklan: [],
    search: '',
    bidder: [],
    IklanSatuan: false,
    unitMokas: [],
    TransaksiDetail: false,
    fotos: [],
    utc: moment().utcOffset() / 60 - 7,
    waktu: '',
    appuser: [],
    IklanPaketan: false,
    motorBekas: [],
    // inijenisIklan: [
    //   { name: "Tawar Bersama", id: "" },
    //   { name: "Iklan Baris", id: "" },
    //   { name: "Aksesoris dan Suku Cadang", id: "" },
    //   { name: "Semua", id: "" }
    // ],
    inijenisIklan: [
      'Tawar Bersama',
      'Iklan Baris',
      'Aksesoris dan Suku Cadang',
      'Semua'
    ],
    dialogBekukan: false,
    alasanBekukan: '',
    dataIklan: [],
    jenis: 'Semua',
    semua: 'Berlangsung',
    limit: 4,
    page: 1,
    offset: 0,
    total: 0,
    lengthPage: 0,
    tandaiSemua: false,
    diTandai: [],
    dataAdmin: '',
    berdasarkan: 'id',
    iniListUser: [],
    daftarUser: false,
    pickIdUser: ''
  }),
  methods: {
    // GetDetailIklan() {
    //   this.$req
    //     .get(this.$root.$baseapi.search+'/search/v3/search', {
    //       params: {
    //         limit: 1,
    //         id: this.search,
    //       },
    //     })
    //     .then((response) => {
    //       let data = response.data;
    //       let { hits } = data.hits;
    //       this.DetailIklan = hits[0];

    //       if (this.DetailIklan._source.id_mst_iklan_type == 1) {
    //         this.unit_mokas(this.DetailIklan._source.unit_motor_bekas[0].id);
    //         this.GetBider(this.DetailIklan._source.id);
    //         this.IklanSatuan = true;
    //         this.IklanPaketan = false;
    //       }
    //       if (this.DetailIklan._source.id_mst_iklan_type == 2) {
    //         this.UnitPaketan();
    //         this.IklanPaketan = true;
    //         this.IklanSatuan = false;
    //         this.GetBider(this.DetailIklan._source.id);
    //       }
    //       this.GetTransaksi(this.DetailIklan._source.id);
    //     })
    //     .catch((error) => {
    //       let responses = error.response.data;
    //       console.log(responses.api_message);
    //     });
    // },
    // GetBider(id) {
    //   db.collection('tawar_bersama')
    //     .doc('iklan')
    //     .collection(String(id))
    //     .limit(5)
    //     .orderBy('Bid', 'desc')
    //     .onSnapshot((querySnapshot) => {
    //       let bidder = [];
    //       querySnapshot.forEach((doc) => {
    //         // bidder.push(doc.data());
    //         // let iklan = [];
    //         this.$req
    //           .get(this.$root.$baseapi.user+'/user/v3/user', {
    //             params: {
    //               id: doc.data().IdAppUser,
    //               limit: 1,
    //             },
    //           })
    //           .then((response) => {
    //             let { data } = response.data;
    //             const dataa = {
    //               IdAppUser: doc.data().IdAppUser,
    //               nama: data[0].nama,
    //               IdUniq: doc.data().IdUniq,
    //               CreatedAt: doc.data().CreatedAt,
    //               Bid: doc.data().Bid,
    //             };
    //             bidder.push(dataa);
    //           })
    //           .catch((error) => {
    //             let responses = error.response.data;
    //             console.log(responses.api_message);
    //           });
    //       });
    //       this.bidder = bidder;
    //     });
    // },
    // UnitPaketan() {
    //   var params = new URLSearchParams();

    //   for (
    //     let index = 0;
    //     index < this.DetailIklan._source.unit_motor_bekas.length;
    //     index++
    //   ) {
    //     const element = this.DetailIklan._source.unit_motor_bekas[index].id;
    //     console.log(element);
    //     params.append('id', element);
    //   }

    //   params.append('limit', this.DetailIklan._source.unit_motor_bekas.length);

    //   var request = {
    //     params: params,
    //   };

    //   this.$req
    //     .get(this.$root.$baseapi.produk+'/produk/v3/unit_mokas', request)
    //     .then((response) => {
    //       let { data } = response.data;
    //       this.motorBekas = data;
    //     })
    //     .catch((error) => {
    //       let responses = error.response.data;
    //       console.log(responses.api_message);
    //     });
    // },
    // unit_mokas(id) {
    //   this.$req
    //     .get(this.$root.$baseapi.produk+'/produk/v3/unit_mokas', {
    //       params: {
    //         id: id,
    //         limit: 1,
    //       },
    //     })
    //     .then((response) => {
    //       let { data } = response.data;
    //       this.unitMokas = data[0];

    //       let foto1 = this.unitMokas.foto_1;
    //       let foto2 = this.unitMokas.foto_2;
    //       let foto3 = this.unitMokas.foto_3;
    //       let foto4 = this.unitMokas.foto_4;
    //       let foto5 = this.unitMokas.foto_5;
    //       this.fotos.push(
    //         { src: foto1 },
    //         { src: foto2 },
    //         { src: foto3 },
    //         { src: foto4 },
    //         { src: foto5 }
    //       );
    //     })
    //     .catch((error) => {
    //       let responses = error.response.data;
    //       console.log(responses.api_message);
    //     });
    // },
    // async GetTransaksi(id_iklan) {
    //   await this.$req
    //     .get(this.$root.$baseapi.transaksi+'/transaksi/v3/order', {
    //       params: {
    //         id_iklan: id_iklan,
    //         limit: 1,
    //       },
    //     })
    //     .then((response) => {
    //       this.TransaksiDetail = response.data.data[0];

    //       this.GetLogTransaksi(this.TransaksiDetail.id);
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //       // this.color.snackbar = 'error';
    //       // this.message = error;
    //       // this.snackbar = true;
    //     });
    // },
    // async GetLogTransaksi(id_order) {
    //   await this.$req
    //     .get(this.$root.$baseapi.log+'/log/v3/log/transaksi', {
    //       params: {
    //         id_order: id_order,
    //         limit: 10,
    //       },
    //     })
    //     .then((response) => {
    //       this.LogTransaksi = response.data.data;
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //       // this.color.snackbar = 'error';
    //       // this.message = error;
    //       // this.snackbar = true;
    //     });
    //   // let ayam = [];
    // },
    async getDataIklan() {
      let offset = (this.page - 1) * this.limit;
      let params = new URLSearchParams();

      // params.append('id_mst_iklan_type', 1)
      // params.append('id_mst_iklan_type', 2)
      // params.append('id_mst_iklan_type', 3)
      if (this.semua == 'Berlangsung') {
        params.append('id_mst_iklan_status', 1);
        params.append('id_mst_iklan_status', 8);
      } else if (this.semua == 'Tayang') {
        params.append('id_mst_iklan_status', 1);
      } else if (this.semua == 'Selesai') {
        params.append('id_mst_iklan_status', 4);
        params.append('id_mst_iklan_status', 2);
        params.append('id_mst_iklan_status', 3);
        params.append('id_mst_iklan_status', 6);
        params.append('id_mst_iklan_status', 9);
      }
      params.append('limit', this.limit);
      params.append('offset', offset);
      if (this.jenis == 'Iklan Baris') {
        params.append('id_mst_iklan_jenis', 1);
      }
      if (this.jenis == 'Tawar Bersama') {
        params.append('id_mst_iklan_jenis', 2);
      }
      if (this.jenis == 'Aksesoris dan Suku Cadang') {
        params.append('id_mst_iklan_jenis', 5);
      }
      params.append('promo', true);
      if (this.berdasarkan == 'id') {
        if (this.search != '') {
          params.append('id', this.search);
        }
      } else if (this.berdasarkan == 'pengguna') {
        if (this.search != '') {
          params.set('id_app_user', this.pickIdUser);
        }
      }

      let request = {
        params: params
      };
      await this.$req
        .get(this.$root.$baseapi.search + '/search/v3/search', request)
        .then(response => {
          let data = response.data;
          let { hits } = data.hits;
          this.dataIklan.push(...hits);
          for (let i = 0; i < this.dataIklan.length; i++) {
            if (this.dataIklan[i]._score == null) {
              this.dataIklan[i]._score = false;
            } else if (this.dataIklan[i]._score == false) {
              this.dataIklan[i]._score = false;
            } else if (this.dataIklan[i]._score == true) {
              this.dataIklan[i]._score = true;
            }
          }

          this.total = data.hits.total.value;
          this.lengthPage = Math.ceil(this.total / this.limit);
          this.page++;
        })
        .catch(error => {
          let responses = error.response.data;
          console.log(responses.api_message);
        });
    },
    async getDataIklanCariId() {
      let params = new URLSearchParams();

      params.set('id_mst_iklan_status', 1);
      params.set('limit', 20);
      if (this.jenis == 'Iklan Baris') {
        params.set('id_mst_iklan_jenis', 1);
      }
      if (this.jenis == 'Tawar Bersama') {
        params.set('id_mst_iklan_jenis', 2);
      }
      if (this.jenis == 'Aksesoris dan Suku Cadang') {
        params.set('id_mst_iklan_jenis', 5);
      }
      if (this.berdasarkan == 'id') {
        if (this.search != '') {
          params.set('id', this.search);
        }
      }

      let request = {
        params: params
      };
      await this.$req
        .get(this.$root.$baseapi.search + '/search/v3/search', request)
        .then(response => {
          let data = response.data;
          let { hits } = data.hits;
          this.dataIklan = hits;
          console.log('tot', this.dataIklan);
        })
        .catch(error => {
          let responses = error.response.data;
          console.log(responses.api_message);
        });
    },
    async tabIklan(data) {
      if (
        data == 'filterJenis' ||
        data == 'cariId' ||
        data == 'searchPengguna'
      ) {
      } else {
        this.semua = data;
      }
      this.dataIklan = [];
      (this.limit = 4),
        (this.page = 1),
        (this.offset = 0),
        (this.total = 0),
        (this.lengthPage = 0),
        this.getDataIklan();
    },
    async tandai(param) {
      let ada = false;
      for (let i = 0; i < this.diTandai.length; i++) {
        if (this.diTandai[i].id == param._id) {
          ada = true;
          this.diTandai.splice(i, 1);
        }
      }
      if (ada == false) {
        this.diTandai.push({ id: param._id });
      }
      if (this.diTandai.length < this.dataIklan.length) {
        this.tandaiSemua = false;
      }
      if (this.diTandai.length == this.dataIklan.length) {
        this.tandaiSemua = true;
      }
      console.log('yang ditandai', this.diTandai);
    },
    async tandaiAll() {
      for (let i = 0; i < this.dataIklan.length; i++) {
        if (this.tandaiSemua == true) {
          this.dataIklan[i]._score = true;
        } else if (this.tandaiSemua == false) {
          this.dataIklan[i]._score = false;
        }
      }
      if (this.tandaiSemua == true) {
        this.diTandai = [];
        for (let i = 0; i < this.dataIklan.length; i++) {
          this.diTandai.push({ id: this.dataIklan[i]._id });
        }
      } else if (this.tandaiSemua == false) {
        this.diTandai = [];
      }
      console.log('yang ditandai', this.diTandai);
    },
    async cariIklan(cari) {
      if (cari == 0) {
        this.dataIklan = [];
        (this.limit = 20),
          (this.page = 1),
          (this.offset = 0),
          (this.total = 0),
          (this.lengthPage = 0),
          this.getDataIklan();
      }
      if (cari != 0) {
        this.getDataIklanCariId();
      }
    },
    async getUser() {
      if (this.berdasarkan != 'id') {
        let params = new URLSearchParams();

        params.set('limit', 5);

        if (this.search != '') {
          params.set('search', this.search);
        }

        let request = {
          params: params
        };
        await this.$req
          .get(this.$root.$baseapi.user + '/user/v3/user', request)
          .then(response => {
            this.iniListUser = response.data.data;
            console.log('data user', this.iniListUser);
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    async memilihUser(item) {
      this.pickIdUser = item.id;
      this.search = item.nama;
      this.daftarUser = false;
      this.tabIklan('searchPengguna');
    }
  },

  computed: {},

  created() {
    if (this.utc == 0) {
      this.waktu = 'WIB';
    }
    if (this.utc == 1) {
      this.waktu = 'WITA';
    }
    if (this.utc == 2) {
      this.waktu = 'WIT';
    }
    this.getDataIklan();
    this.getUser();
    this.idAdmin = localStorage.getItem('id');

    console.log('adad', this.idAdmin);
  },
  filters: {
    dateTimeFormat: (date, utc) => {
      return moment
        .utc(date)
        .add(utc, 'h')
        .format('DD MMM YYYY HH:mm');
    },
    TimeFormat: (date, utc) => {
      return moment
        .utc(date)
        .add(utc, 'h')
        .format('HH:mm');
    },
    dateFormat: (date, utc) => {
      return moment
        .utc(date)
        .add(utc, 'h')
        .format('DD MMM YYYY');
    },
    datediff: date => {
      return moment(date).from();
    }
  }
};
</script>
